<template>
  <div>
    <p>
      <StrongI18n
        data-test="category-to-delete"
        keypath="row_categories.confirm_delete"
        :values="{propName: categoryToDelete.name}"
      />
    </p>
    <p class="text-danger">{{ $t('row_categories.confirm_delete_warning') }}</p>
    <div class="text-right">
      <button
        type="button"
        class="btn btn-default"
        @click="backToList({})"
        data-test="cancel-delete-button"
      >
        {{ $t('row_categories.confirm_delete_no') }}
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="deleteCategory(categoryToDelete.id)"
        data-test="confirm-delete-button"
      >
        {{ $t('filters.confirm_delete_yes') }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'ConfirmDeleteRowCategory',
  components: {
    StrongI18n
  },
  computed: {
    ...mapState({
      categoryToDelete: state => state.rowCategoriesModule.categoryToDelete,
      error: state => state.error
    })
  },
  methods: {
    ...mapActions('rowCategoriesModule', ['backToList', 'deleteRowCategory']),
    deleteCategory(id) {
      this.deleteRowCategory({id}).then(
        function () {
          if (this.error === undefined) {
            this.backToList({reloadCategories: true});
          }
        }.bind(this)
      );
    }
  }
};
</script>

<style scoped>
button {
  margin: 0 0.5em;
}
</style>
